import { http } from '@/http/axios.js'
export function getLoginCodeAPI(mobile) {
  return http({
    url: '/adminapi/auth/login/code',
    method: 'post',
    data: {mobile}
  })
}
